import { Commission } from './commission';

export const enum CommissionRecalculationTaskStatus {
  Created = 'created',
  Pending = 'pending',
  InProgress = 'processing',
  Completed = 'completed',
}

export type CommissionRecalculationTaskStatusRecord = {
  id: string;
  '@id': string;
  description: string;
  name: string;
  value: CommissionRecalculationTaskStatus;
};

export type CommissionRecalculationTask = {
  commission: Commission;
  completedAt: string;
  createdAt: string;
  id: string;
  '@id': string;
  processedOrdersCount: number;
  totalOrdersCount: number;
  recalculateFrom: number;
  recalculateTo: number;
  startedAt: string;
  status: CommissionRecalculationTaskStatusRecord;
  timeZone: string;
};
